export {}; // Rend ce fichier en tant que module pour éviter les erreurs

declare global {
  interface String {
    format(...values: string[]): string;
    toCapitalize(): string;
  }
}

String.prototype.format = function (...values: string[]): string {
  return this.replace(/{(\d+)}/g, (match, index) => values[index] || '');
};

String.prototype.toCapitalize = function (): string {
  return this[0].toUpperCase() + this.slice(1);
};
